import classes from './ModalPackAdd.module.css';

import attentionIcon from 'assets/svg/attention-01.svg';

import { postSavePack } from 'services/pucks.services';
import { useForm, FormProvider } from 'react-hook-form';

import FormTextField from 'ui/formItems/FormTextField';
import { observer } from 'mobx-react-lite';
import useAlert from 'hooks/useAlert';
import classNames from 'classnames';
import Modal from 'ui/Modal';

const ModalPackAdd = observer(({ openModal, packData, onClose }) => {
  const { showAlert } = useAlert();

  const form = useForm({
    defaultValues: {
      name: '',
      column: 1,
      lines: 1,
      column_name: '',
      lines_name: '',
      ...JSON.parse(JSON.stringify(packData)),
    },
  });

  const {
    handleSubmit,
    formState: { errors },
  } = form;

  const savePuck = async (data) => {
    const res = await postSavePack(data);
    if (res.success) {
      alarmAddedPackAlert();
      onClose();
    } else {
      errorCommon(res.error_code);
    }
  };

  const errorCommon = (code) =>
    showAlert(` Код № ${code}: Число столбцов или строк не совпадает!`, 'error');

  const alarmAddedPackAlert = () => {
    showAlert(`Тип добавлен успешно!`, 'success');
  };

  if (!openModal) return null;

  return (
    <Modal title="Добавить тип штатива" onSubmit={handleSubmit(savePuck)} onClose={onClose}>
      <FormProvider {...form}>
        <div className={classes.modal}>
          <FormTextField
            className={classes.infoItemValue}
            name="name"
            label="Наименование"
            required
          />
          <div>
            <FormTextField
              label="Столбцов"
              className={classes.infoItemValue}
              name="column"
              type="number"
              hideErrorBlock={true}
              required
              rules={{
                validate: {
                  required: (value) => {
                    if (value === '' || value === undefined || value === null) {
                      return 'Поле обязательно для заполнения';
                    }
                    return true;
                  },
                  numberValidation: (value) => {
                    const num = Number(value);
                    if (isNaN(num)) return 'Введите число';
                    if (num < 1) return 'Должно быть больше 0';
                    return true;
                  },
                },
              }}
            />
            {errors?.column && (
              <div className={classes.dataErrorBlock}>
                <img src={attentionIcon} alt={'attention'} />
                <div className={classes.dataError}>{errors?.column?.message}</div>
              </div>
            )}
          </div>
          <div>
            <FormTextField
              label="Строк"
              className={classes.infoItemValue}
              name="lines"
              type="number"
              hideErrorBlock={true}
              required
              rules={{
                validate: {
                  required: (value) => {
                    if (value === '' || value === undefined || value === null) {
                      return 'Поле обязательно для заполнения';
                    }
                    return true;
                  },
                  numberValidation: (value) => {
                    const num = Number(value);
                    if (isNaN(num)) return 'Введите число';
                    if (num < 1) return 'Должно быть больше 0';
                    return true;
                  },
                },
              }}
            />
            {errors?.lines && (
              <div className={classes.dataErrorBlock}>
                <img src={attentionIcon} alt={'attention'} />
                <div className={classes.dataError}>{errors?.lines?.message}</div>
              </div>
            )}
          </div>
          <div className={classes.infoItem_column}>
            <>
              <label className={classNames(classes.infoItemName, classes.mb5)}>
                Обозначение столбцов, через запятую
              </label>
              <div className={classes.bgWhite}>
                <FormTextField
                  label="Столбцы"
                  className={classes.infoItemValue}
                  name="column_name"
                  required
                />
              </div>
            </>
          </div>
          <div className={classes.infoItem_column}>
            <>
              <label className={classNames(classes.infoItemName, classes.mb5)}>
                Обозначение строк, через запятую
              </label>
              <div className={classes.bgWhite}>
                <FormTextField
                  label="Строки"
                  className={classes.infoItemValue}
                  name="lines_name"
                  required
                />
              </div>
            </>
          </div>
        </div>
      </FormProvider>
    </Modal>
  );
});

export default ModalPackAdd;
